import { selectChangeMessageForThemes } from '@UI/aside/asideThemes/AsideThemesSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectKrcGoalSetItemNode } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import {
  NodeType,
  type BuildingBlockNodeConfig,
  type EditAsideThemes,
} from '@nodeTypeConfig/configTypes';
import { selectIsGoalSetItemOrderValid } from '@newStore/validation/validationRules/krcGoalSetItemOrderValidation';
import { selectIsGoalSetItemThemeUnique } from '@newStore/validation/validationRules/krcGoalSetItemDuplicateThemeValidation';
import { referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { optionalTitleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const krcGoalSetThemeComponent: EditAsideThemes = {
  component: 'themes',
  property: 'themes',
  reactComponent: 'AsideThemes',
  label: 'Doelenset',
  options: {
    referenceFrameHref: referenceFrames.krc,
    types: [ContentType.KRC_GOAL_SET],
  },
  asideChangeMessageSelector: selectChangeMessageForThemes,
};

const KRC_GOAL_SET_ITEM: BuildingBlockNodeConfig = {
  nodeSelector: selectKrcGoalSetItemNode,
  information: {
    single: 'Doelenset item',
    plural: 'Doelenset items',
  },
  /**
   * we hide the KRC_AGE_RANGE_ITEM from the ribbon, because it's an auto-created child of the KRC_GOAL_SET_ITEM, and we don't want users to add it themselves.
   * We can't use createChildDefaults because they only take a static array of nodes. A refactor to make createChildDefaults more flexible would be possible, but for now this is the easiest solution.
   */
  buildingBlocks: [{ type: NodeType.KRC_AGE_RANGE_ITEM, hideInRibbon: true }],
  edit: [identifierComponent, optionalTitleComponent, krcGoalSetThemeComponent],
  validationRules: [selectIsGoalSetItemOrderValid, selectIsGoalSetItemThemeUnique],
  readOnlyNode: true,
  isCollapsible: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default KRC_GOAL_SET_ITEM;
